import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from './pt';
import en from './en';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'en',
  messages: { pt, en },
});

export default i18n;
